module.exports = __webpack_public_path__ + "media/images/flags/4x3/eun-6dd98b24442f62b69350c35e4d2c2884.svg";